/**
 * Get the URL parameters
 * source: https://css-tricks.com/snippets/javascript/get-url-variables/
 * @param  {String} url The URL
 * @return {Object}     The URL parameters
 */
var getParam = function (param, url) {
  url = url ? url : window.location.href;
  var params = {};
  var parser = document.createElement('a');
  parser.href = url;
  var query = parser.search.substring(1);
  var vars = query.split('&');

  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    params[pair[0]] = decodeURIComponent(pair[1]);
  }

  if (params[param]) {
    return params[param];
  }

  return false;
};

window.addEventListener("load", function () {
  document.querySelector(".custom-btn-shoppay")?.classList.remove("default-checkout");
});

$(function () {
  //PDP -- shoppay action
  let shopPayButton = document.querySelector(".custom-btn-shoppay");
  if (shopPayButton) {
    shopPayButton.addEventListener("click", function (e) {
      document.querySelector("[data-loader]").classList.remove("hide");
      let dynamicCheckout = document.querySelector(
        ".product-single__details div[data-testid=ShopifyPay-button]"
      );
      if (
        shopPayButton.classList.contains("default-checkout") ||
        !dynamicCheckout
      ) {
        // If dynamic checkout buttons do not load or shoppay clicked befoer the page load, default checkout else go to Shoppay
        document.querySelector('form[action$="/cart/add"]').submit();
      } else {
        let variantId = document.querySelector(
          'form[action$="/cart/add"] .product-form__variants'
        ).value;
        fetch("/cart/add?id=" + variantId + "&quantity=1")
          .then((response) => {
            document
              .querySelector(
                ".product-single__details div[data-testid=ShopifyPay-button]"
              )
              .click();
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    });
  }

  var headerHeight = $('.site-header').height();

  // Smooth scroll links
  (function () {
    $('a[href^="#"]:not([data-smooth-scroll="false"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .not('[role="tab"]')
      .on('click', function (event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top - headerHeight
            }, 700);
          }
        }
      });
  })();

  (function () {
    if (!document.body.classList.contains('template-reviews')) {
      return;
    }

    if (!getParam('device')) {
      return;
    }

    var target = document.querySelector('#reviewsNav .nav-link[data-category="' + getParam('device') + '"]');

    if (!target) {
      return;
    }

    target.click();
  })();

  // Open Quiz links in new tab
  document.querySelectorAll('a[href*="/quiz/"]').forEach(function (link) {
    link.setAttribute('target', '_blank');
  });

  $('.video-link').on('click', function (event) {
    event.preventDefault();

    var $src = $(this).data('popup-video'),
      $popup = $('#video-modal'),
      $content = '<div class="popup-video"><div class="popup-video-main"><iframe id="player" type="text/html" width="100%" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen src="' + $src + '" data-video-player></iframe></div></div>';

    $popup.find('.modal-body').html($content);

    theme.HaloAddOn.videoPopup();
  })

  $('.video-cta').on('click', function (event) {
    event.preventDefault();
    var $this = $(this);

    $this.fadeOut().siblings('iframe').attr('src', ($this.data('target')));
  });
});

(function () {
  let textElement = document.querySelector('[data-message-text]:not([style*="display: none"])');
  if (!textElement) {
    return
  }
  let textElementParent = textElement.parentNode;

  let textElementAfterClick = document.querySelector('[data-message-text-after-click]');

  textElementParent.addEventListener('click', function () {
    navigator.clipboard.writeText(textElement.textContent.split('Code: ')[1].trim());

    textElementParent.classList.add('hide')
    textElementAfterClick.classList.remove('hide')
  })
})();

(function () {
  let menuItem = document.querySelectorAll('.site-nav>.menu-lv-1.dropdown');
  let header = document.querySelector('.site-header');
  let topHeader = document.querySelector('.announcement-bar').height;

  // menuItem.forEach(function(el){
  //   el.addEventListener('mouseover', () => {
  //     if (!header.classList.contains('is-sticky')) {
  //       header.style.cssText = 'z-index: 99';
  //     }
  //   })

  //   el.addEventListener('mouseleave', () => {
  //     if (!header.classList.contains('is-sticky')) {
  //       header.style.cssText = 'z-index: auto';
  //     }
  //   })
  // })

  // window.addEventListener('scroll', () => {
  //   if (header.classList.contains('is-sticky')) {
  //     header.style.cssText = "z-index: 99; top: ${topHeader}";
  //   } else {
  //     header.style.cssText = 'z-index: auto; top: 0';
  //   }
  // })

})();
